import { CommonService } from "../common.service";
var StaffTalkComponent = (function () {
    function StaffTalkComponent(commonService) {
        this.commonService = commonService;
        this.isHarmonyOS = false; //是否鸿蒙系统
    }
    StaffTalkComponent.prototype.ngOnInit = function () {
        this.isHarmonyOS = this.commonService.isHarmonyOS();
    };
    StaffTalkComponent.prototype.ngAfterViewInit = function () {
        var htmlFontSize = document.documentElement.clientWidth / 7.5;
        document.documentElement.style.fontSize = htmlFontSize + "px";
        if (this.talk.length > 13) {
            $(".talk_item").last().width($("#test").width());
        }
    };
    return StaffTalkComponent;
}());
export { StaffTalkComponent };



// WEBPACK FOOTER //
// ./src/app/staff-talk/staff-talk.component.ts.pre-build-optimizer.js